<ion-content class="ion-padding text-info">
  <span class="text-info">{{info}}</span>
</ion-content>
